import { render, staticRenderFns } from "./NominationFormEdit.vue?vue&type=template&id=144e84a5"
import script from "./NominationFormEdit.vue?vue&type=script&lang=js"
export * from "./NominationFormEdit.vue?vue&type=script&lang=js"
import style0 from "./NominationFormEdit.vue?vue&type=style&index=0&id=144e84a5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports